import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { onError } from 'lp-hoc'
import { logException } from 'sentry'
import { Header, Footer } from 'components'
import { initializeAnonymousUserflow, useCommunity } from 'utils'
import useMapDocumentTitle from './use-map-document-title'

const propTypes = {
  children: PropTypes.node,
}

function Layout({ children }) {
  useMapDocumentTitle()

  // Temporarily disable userflow on public facing sites
  // for every community but Baltimore
  const community = useCommunity()
  if (community.name === 'Baltimore') {
    initializeAnonymousUserflow()
  }

  return (
    <div className="map">
      <Header />
      <main id="content">
        {children}
        <Footer />
      </main>
    </div>
  )
}

Layout.propTypes = propTypes

function onComponentDidCatch(_, error, errorInfo) {
  return logException(error, errorInfo)
}

export default compose(onError(onComponentDidCatch))(Layout)
